<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >
                    <div class="header-image-gradient" style="background-image: url(static/images/img1.jpg);">
                        <div class="layer-gradient"></div>
                    </div>

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>
                        
                    <!-- Row -->
                    <div class="row">
                        <div class="col-lg-12">
                            <p class="page-text margin-bottom-20 margin-top-0">
                                Envie os seus exames e fotos do tratamento, eles serão armazenados com segurança e estarão disponíveis aqui quando você precisar.
                            </p>
                        </div>                           

                        <div class="col-xl-12" v-show="data.loaded">
                            <div  class="margin-bottom-15">
                                <div class="row">
                                    <div class="col-lg-6 col-xs-12 ">

                                        <form method="post" v-on:submit.prevent="submit" novalidate="" v-bind:class="{'disabled': loading.submit}" class="margin-bottom-0">
                                            <div class="uploadButton margin-bottom-0" style="width: 48%; display: inline-block;">
                                                <input class="uploadButton-input" type="file" name="arquivo" @change="getBase64Arquivo" accept="image/*,.pdf,application/pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" :id="'upload-arquivo-'" />
                                                <label class="uploadButton-button gray" style="font-size: 14px; padding-left: 0px; padding-right: 0px;" :for="'upload-arquivo-'">
                                                    <i class="material-icons">attach_file</i>
                                                    Enviar arquivo
                                                </label>
                                                <span class="uploadButton-file-name"></span>
                                            </div>              
                                            <button type="button" class="button color-primary" v-on:click="foto()" style="width: 48%; display: inline-block; float: right; font-size: 14px; padding-left: 0px; padding-right: 0px;">
                                                <i class="material-icons">photo</i>
                                                Tirar foto
                                            </button>
                                        </form>  

                                        <div class="margin-bottom-20 hidden-xs"></div>
                                    </div>
                                    <div class="col-lg-12">
                                        <h5 class="center empty" v-show="data.itens.length == 0">
                                            <i class="material-icons">close</i>                                            
                                            Nenhum arquivo enviado.
                                        </h5>
                                        <div class="attachments-container" v-if="data.itens.length > 0">
                                            <div class="attachment-box" v-for="(item, index) in data.itens">
                                                <a :href="$root.config.url + '/' + item.arquivo" v-if="item.tipo == 'pdf' || item.tipo == 'doc' || item.tipo == 'docx'" class="center" target="_blank" style="cursor: pointer;">
                                                    <div  class="preview" style="">
                                                        <div class="material-icons" style="font-size: 90px; margin-top: 30px; opacity: 0.5;">insert_drive_file</div>
                                                    </div>
                                                </a>
                                                <a :href="$root.config.url + '/' + item.arquivo" v-if="item.tipo == 'jpg' || item.tipo == 'jpeg' || item.tipo == 'png'" target="_blank" style="cursor: pointer;">
                                                    <div  :style="{'background-image': 'url(' + $root.config.url + '/' + item.arquivo + ')'}" class="preview"></div>
                                                </a>
                                                <span>
                                                    <a :href="$root.config.url + '/' + item.arquivo" target="_blank" style="cursor: pointer;">
                                                        {{item.nome}}
                                                    </a>
                                                </span>
                                                <small>
                                                    <div class="material-icons">info</div>
                                                    ID <b>#{{item.id}}</b>
                                                    <div class="material-icons">access_time</div>
                                                    {{item.datahora | formatDate}}
                                                </small>                                              
                                                <i>{{item.tipo}}</i>
                                                <div class="buttons" v-if="$root.user.tipo == 'admin' || item.usuarioCod == $root.user.cod">
                                                    <button v-on:click.prevent="del(item.cod)" type="button" class="dashboard-status-button gray float-right">
                                                        <i class="material-icons">delete</i> Apagar
                                                    </button>                                                    
                                                    <button v-on:click.prevent="editar(item.cod, item.nome)" type="button" class="dashboard-status-button gray float-right">
                                                        <i class="material-icons">edit</i> Renomear
                                                    </button>
                                                </div>                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>   
                            </div>
                        </div>  
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Arquivos',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            return date + " " + time;
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },    
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "visualizar": {
                "itens":            []
            },
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },           
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token
            },
        }
    },
    watch: {
                  
    },
    methods: {   
        foto: function() {
            var self = this;
            navigator.camera.getPicture(function(imageData) {
                console.log("getPicture callback", imageData)
                self.form.arquivo   = "data:image/jpeg;base64," + imageData;
                self.form.nome      = "Foto";
                self.submit();
            }, function(message){
                console.log("getPicture erro:", message)
            }, {
                quality: 35,
                // saveToPhotoAlbum: true,
                destinationType: Camera.DestinationType.DATA_URL,
                targetWidth: 1000,
                correctOrientation: true,
                targetHeight: 0
            });  
        }, 
        getBase64Arquivo: function(event) {
            var self            = this;
            if (event.target.files[0]) {
                loading.show();
                reduceFileSize(event.target.files[0], 500*1024, 1000, Infinity, 0.9, blob => {
                    blobToBase64(blob, function(result) {
                        // loading.hide();
                        self.form.arquivo   = result;

                        // var nome            = prompt("Qual o nome do arquivo?", event.target.files[0].name);
                        // if (!nome) {
                            // loading.hide();
                            // return false;
                        // }
                        self.form.nome      = event.target.files[0].name;
                        self.$forceUpdate();
                        self.submit();
                    });
                }); 
            }   
        },         
        submit: function() {
            var self            = this;
            console.log("submit()");
            
            // self.loading.submit = true;
            loading.show();
                
            axios.post("api/arquivos.php", self.form)
            .then(response => {
                
                self.loading.submit = false;
                console.log("submit() response", response)
                // loading.hide();
                // alert(response.data.message);
                self.get().then(function() {
                    self.form.arquivo   = null;
                    self.form.nome      = "";
                    self.$forceUpdate();
                    loading.hide();
                }).catch(function() {
                    loading.hide();
                });
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        editar: function(cod, nome) {
            var self            = this;
            console.log("editar()");
            
            // self.loading.submit = true;
            var form            = JSON.parse(JSON.stringify(self.form));
            form.cod            = cod;
            var novoNome        = prompt("Editar o nome do arquivo", nome);
            if (!novoNome) {
                return false;
            }
            form.nome      = novoNome;
            loading.show();

            axios.put("api/arquivos.php", form)
            .then(response => {
                
                self.loading.submit = false;
                console.log("submit() response", response)
                // loading.hide();
                // alert(response.data.message);
                self.get().then(function() {
                    loading.hide();
                }).catch(function() {
                    loading.hide();
                });
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },          


        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar esse item?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                self.loading.del        = true;
                loading.show();
                
                axios.delete("api/arquivos.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.loading.del    = false;
                    self.get().then(function() {
                        loading.hide();
                    }).catch(function() {
                        loading.hide();
                    });                 
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    self.loading.del    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },             
        get: function() {
            var self        = this;
            console.log("get()");
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token
                    }
                };

                axios.get("api/arquivos.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data           = JSON.parse(JSON.stringify(response.data.result));
                    self.$forceUpdate();
                    console.log(">", self.data)
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        }
    },
    created: function() {
        var self = this;

        loading.show();

        Promise.all([
            self.get()
        ]).then(function() {
        
            self.$forceUpdate();
            loading.hide();
            
        }).catch(function(error) {
            loading.hide();
        });         

    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .table td button i {
        font-size: 20px !important;
        color: #fff;
    }
    .table td button {
        margin-top: 0px !important;
    }
    .table td {
        /*border-right: none;*/
        /*border-left: none;*/
    }
    .table td input, .table td select {
        margin-top: 0px;
        margin-bottom: 0px;
        text-align: left
    }
    .read-only {
        pointer-events: none !important;
        -webkit-touch-callout: none;                /* prevent callout to copy image, etc when tap to hold */
        -webkit-text-size-adjust: none;             /* prevent webkit from resizing text to fit */
        -webkit-user-select: none;             
    }
    .attachment-box {
        border: none !important;
    }
    div.float-right {
        float: right;
        display: inline-block;
    }
    .buttons {
        position: absolute;
        bottom: 10px;
        right: 10px;        
    }
    .attachment-box small div {
        font-size: 12px;
    }
    .attachment-box small {
        color: #888;
        display: block;
        font-weight: 300;
    }
    .attachment-box span {
        font-size: 16px !important;
        margin-bottom: 5px;
    }
    .dashboard-status-button {
        padding-top: 0px;
        margin-right: 5px;
        color: #333;
        font-weight: 300;
        padding-top: 2px !important;
        line-height: 20px;
        top: 0px;
        margin-top: 10px;
        border: 1px solid #ddd;
    }
    .dashboard-status-button i {
        /*color: #fff;*/
        display: inline-block !important;
        top: 1px;
        margin-top: 0px;
    }
    .attachment-box .preview {
        background-size: cover; 
        background-position: center; 
        background-repeat: no-repeat; 
        background-color: #fff;
        /*border: 1px solid #ddd;  */
        height: 150px;
        margin-bottom: 10px;
        display: block;     
        /*border-radius: 10px;*/
        margin-left: -18px;
        margin-right: -23px;
        margin-top: -13px;
        z-index: -1;
    }
</style>



// WEBPACK FOOTER //
// src/components/Arquivos.vue